import React from 'react';

import DrawerPage from 'components/layout/drawer-page';
import { t } from 'state/intl/translations';

import { Configs } from './views/configs';

export default function DiagnosticsScreen() {
  return (
    <DrawerPage headerText={t('diagnostics')}>
      <Configs />
    </DrawerPage>
  );
}
